export default __webpack_public_path__ + "static/media/banner 2web.ceb906ff.png";